import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
        <h1 className="font-heading font-bold text-xl text-slate-900 mb-2">Nuova password</h1>
        {done ? (
          <p data-testid="reset-success" className="text-sm text-emerald-700">Password aggiornata. Reindirizzamento al login…</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="reset-password-input" type="password" required minLength={8} value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="Nuova password (min. 8 caratteri)"
              className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />
            {error && <div data-testid="reset-error" className="text-sm text-red-600">{error}</div>}
            <button data-testid="reset-submit-button" type="submit"
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-md py-2 text-sm transition-colors">
              Imposta password
            </button>
          </form>
        )}
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-indigo-600 hover:underline">Torna al login</Link>
        </div>
      </div>
    </div>
  );
}
